/* MkaeSense: white-background cutout + light-photo tiles + premium mobile menu + card price styling + PDP trust strip */
(function(){
  var SEL='product-card img, .product-card img, .card-gallery img, .product-media img, media-gallery img, .product-media-container img';
  var cache={}, cutCache={};

  /* Remove a plain white background so the product floats on the black page. Returns a canvas or null. */
  function cut(probe){
    var W=Math.min(probe.naturalWidth,900), H=Math.round(probe.naturalHeight*W/probe.naturalWidth);
    if(!W||!H) return null;
    var c=document.createElement('canvas'); c.width=W; c.height=H; var g=c.getContext('2d',{willReadFrequently:true}); g.drawImage(probe,0,0,W,H);
    var id=g.getImageData(0,0,W,H), d=id.data, n=W*H;
    function m(i){var o=i*4; return Math.min(d[o],d[o+1],d[o+2]);}
    var bt=0,bw=0,x,y;
    for(x=0;x<W;x++){bt+=2;if(m(x)>=228)bw++;if(m((H-1)*W+x)>=228)bw++;}
    for(y=0;y<H;y++){bt+=2;if(m(y*W)>=228)bw++;if(m(y*W+W-1)>=228)bw++;}
    if(bw/bt<0.6) return null;
    var T=130, LO=140, HI=242, G=2.2;
    var vis=new Uint8Array(n), st=new Int32Array(n), sp=0, seen=0;
    function push(i){ if(!vis[i]&&m(i)>=T){vis[i]=1;st[sp++]=i;seen++;} }
    for(x=0;x<W;x++){push(x);push((H-1)*W+x);}
    for(y=0;y<H;y++){push(y*W);push(y*W+W-1);}
    while(sp){var i=st[--sp]; x=i%W; y=(i/W)|0; if(x>0)push(i-1); if(x<W-1)push(i+1); if(y>0)push(i-W); if(y<H-1)push(i+W);}
    if(seen/n>0.88) return null;
    /* text-heavy infographics have many separate foreground pieces: leave those as tiles so dark text stays readable */
    var lab=new Uint8Array(n), comps=0, s0;
    for(s0=0;s0<n&&comps<=14;s0++){
      if(vis[s0]||lab[s0]) continue;
      var sz=0; lab[s0]=1; st[0]=s0; sp=1;
      while(sp){ var q=st[--sp]; sz++; var qx=q%W, qy=(q/W)|0;
        if(qx>0&&!vis[q-1]&&!lab[q-1]){lab[q-1]=1;st[sp++]=q-1;}
        if(qx<W-1&&!vis[q+1]&&!lab[q+1]){lab[q+1]=1;st[sp++]=q+1;}
        if(qy>0&&!vis[q-W]&&!lab[q-W]){lab[q-W]=1;st[sp++]=q-W;}
        if(qy<H-1&&!vis[q+W]&&!lab[q+W]){lab[q+W]=1;st[sp++]=q+W;}
      }
      if(sz>=20) comps++;
    }
    if(comps>14) return null;
    var removed=0, minx=W,maxx=0,miny=H,maxy=0;
    for(var j=0;j<n;j++){ var o=j*4;
      if(vis[j]){ var mm=m(j), a0=(HI-mm)/(HI-LO); a0=a0>1?1:a0;
        var a= mm>=HI?0 : Math.pow(a0,G);
        if(a<=0.01){d[o+3]=0;removed++;} else { for(var k=0;k<3;k++){ var v=(d[o+k]-255*(1-a0))/(a0||1); d[o+k]=v<0?0:v>255?255:v; } d[o+3]=Math.round(a*255); } }
      if(d[o+3]>40){var x2=j%W,y2=(j/W)|0; if(x2<minx)minx=x2; if(x2>maxx)maxx=x2; if(y2<miny)miny=y2; if(y2>maxy)maxy=y2;}
    }
    var frac=removed/n, box=((maxx-minx)*(maxy-miny))/n;
    if(frac<0.12||frac>0.93||box<0.06) return null;
    g.putImageData(id,0,0); return c;
  }
  function apply(img,u){ img.dataset.mkCut='1'; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src=u; img.classList.remove('mk-lightimg'); img.classList.add('mk-cut'); }

  function sample(img){
    if(img.dataset.mkCut) return;
    var src=img.currentSrc||img.src; if(!src) return;
    if(cutCache[src]){ apply(img,cutCache[src]); return; }
    if(cache[src]!==undefined){ if(cache[src]) img.classList.add('mk-lightimg'); return; }
    if(img.dataset.mkChecked===src) return; img.dataset.mkChecked=src;
    var probe=new Image(); probe.crossOrigin='anonymous';
    probe.onload=function(){
      try{
        var c=document.createElement('canvas'); c.width=24; c.height=24; var g=c.getContext('2d');
        g.drawImage(probe,0,0,24,24); var d=g.getImageData(0,0,24,24).data, s=0, n=0;
        for(var y=0;y<24;y++)for(var x=0;x<24;x++){ if(x<2||y<2||x>21||y>21){ var k=(y*24+x)*4; s+=(d[k]+d[k+1]+d[k+2])/3; n++; } }
        var light=(s/n)>=110; cache[src]=light;
        if(!light){ img.classList.remove('mk-lightimg'); return; }
        var cv=null; try{ cv=cut(probe); }catch(e){}
        if(cv && cv.toBlob){ cv.toBlob(function(b){ if(!b){ img.classList.add('mk-lightimg'); return; } var u=URL.createObjectURL(b); cutCache[src]=u; apply(img,u); }); }
        else img.classList.add('mk-lightimg');
      }catch(e){}
    };
    probe.src=src;
  }
  function scan(root){ (root||document).querySelectorAll(SEL).forEach(function(im){ if(im.complete&&im.naturalWidth) sample(im); else im.addEventListener('load',function(){sample(im)},{once:true}); }); }

  /* split "$59.99 CAD" into amount + muted currency */
  function prices(root){
    (root||document).querySelectorAll('product-card .price bdi').forEach(function(b){
      if(b.dataset.mkP) return; var t=b.textContent.trim(); var m=t.match(/^(.*?)\s+(CAD|USD)$/);
      if(!m) return; b.dataset.mkP='1'; b.innerHTML=m[1]+' <small class="mk-cur">'+m[2]+'</small>';
    });
  }

  /* trust strip under the buy buttons on product pages */
  function trust(){
    if(document.querySelector('.mk-trust')) return;
    var bb=document.querySelector('.buy-buttons-block'); if(!bb||!bb.parentNode) return;
    var ul=document.createElement('ul'); ul.className='mk-trust';
    ul.innerHTML='<li><svg viewBox="0 0 24 24"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg><span><strong>Free shipping</strong>on orders over $75</span></li>'+
      '<li><svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 3-6.2"/><path d="M4 4v4h4"/></svg><span><strong>30-day returns</strong>On unused items</span></li>'+
      '<li><svg viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg><span><strong>1-year warranty</strong>Against defects</span></li>'+
      '<li><svg viewBox="0 0 24 24"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg><span><strong>Tracked delivery</strong>Canada &amp; US</span></li>';
    bb.parentNode.insertBefore(ul,bb.nextSibling);
  }

  var ICON={
    cottage:'<svg viewBox="0 0 24 24"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-5h4v5"/></svg>',
    car:'<svg viewBox="0 0 24 24"><path d="M5 16l1.5-5.5A2 2 0 0 1 8.4 9h7.2a2 2 0 0 1 1.9 1.5L19 16"/><rect x="3" y="16" width="18" height="4" rx="1.5"/><circle cx="7.5" cy="18" r=".6"/><circle cx="16.5" cy="18" r=".6"/></svg>',
    porch:'<svg viewBox="0 0 24 24"><path d="M4 8l8-4 8 4v12H4z"/><path d="M9 20v-6h6v6"/><circle cx="12" cy="10" r="1"/></svg>',
    power:'<svg viewBox="0 0 24 24"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg>'
  };
  function injectDrawer(){
    document.querySelectorAll('.menu-drawer').forEach(function(d){
      if(d.dataset.mkDrawer) return; var nav=d.querySelector('.menu-drawer__navigation'); if(!nav) return; d.dataset.mkDrawer='1';
      var top=document.createElement('div'); top.className='mk-drawer-top';
      top.innerHTML='<p class="mk-drawer-eyebrow">Shop by what you\'re protecting</p><div class="mk-drawer-tiles">'+
        '<a href="/collections/cottage-security">'+ICON.cottage+'<span>Cottage</span></a>'+
        '<a href="/collections/car-theft-protection">'+ICON.car+'<span>Car theft</span></a>'+
        '<a href="/collections/porch-pirate-protection">'+ICON.porch+'<span>Porch</span></a>'+
        '<a href="/collections/power-outage-ready">'+ICON.power+'<span>Power outage</span></a></div><p class="mk-drawer-eyebrow mk-drawer-eyebrow--second">Browse everything</p>';
      nav.parentNode.insertBefore(top,nav);
      var foot=document.createElement('div'); foot.className='mk-drawer-foot';
      foot.innerHTML='<ul><li>Free shipping over $75</li><li>No camera subscriptions</li><li>30-day returns</li></ul><a href="mailto:mkaesense@outlook.com">mkaesense@outlook.com</a>';
      nav.parentNode.insertBefore(foot,nav.nextSibling);
    });
  }
  function tick(){ scan(document); prices(document); trust(); injectDrawer(); }
  function start(){ tick(); new MutationObserver(tick).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
